module.exports = __webpack_public_path__ + "img/other_pay_pi2.39ff1740.svg";